var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTeleconsult = function SvgTeleconsult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.4-Sidebar-/-All",
    transform: "translate(-16.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.003069, 3.000290)",
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2156813,13.9998311 C10.6056813,13.9998311 9.74880629,13.7790851 8.46568128,13.0622101 C6.90536877,12.1872101 5.69849376,11.3793976 4.14661875,9.83158512 C2.65036874,8.33627261 1.92224374,7.36814761 0.903181231,5.51377259 C-0.248068776,3.42002258 -0.0518187746,2.32252257 0.167556227,1.85346007 C0.428806228,1.29283507 0.814431231,0.957522566 1.31286873,0.624710064 C1.59597815,0.439221159 1.89557818,0.280215557 2.20786874,0.149710061 C2.23911874,0.136272561 2.26818124,0.123460061 2.29411874,0.11189756 C2.44880624,0.04221006 2.68318124,-0.0631024406 2.98005624,0.0493975601 C3.17818125,0.123772561 3.35505625,0.275960061 3.63193125,0.549397563 C4.19974375,1.10939757 4.97568126,2.35658507 5.26193126,2.96908508 C5.45411876,3.38189758 5.58130626,3.65439758 5.58161876,3.96002258 C5.58161876,4.31783509 5.40161876,4.59377259 5.18318126,4.89158509 C5.14224376,4.94752259 5.10161876,5.00096009 5.06224376,5.05283509 C4.82443126,5.36533509 4.77224376,5.45564759 4.80661876,5.61689759 C4.87630626,5.9409601 5.39599376,6.9056476 6.25005626,7.75783511 C7.10411877,8.61002261 8.04099378,9.09689762 8.36630628,9.16627262 C8.53443128,9.20221012 8.62661878,9.14783512 8.94911878,8.90158512 C8.99536878,8.86627262 9.04286878,8.82971011 9.09255628,8.79314761 C9.42568128,8.54533511 9.68880629,8.37002261 10.0381813,8.37002261 L10.0400563,8.37002261 C10.3441188,8.37002261 10.6044313,8.50189761 11.0356813,8.71939761 C11.5981813,9.00314762 12.8828688,9.76908512 13.4463063,10.3375226 C13.7203688,10.6137726 13.8731813,10.7900226 13.9478688,10.9878351 C14.0603688,11.2856476 13.9544313,11.5190851 13.8853688,11.6753351 C13.8738063,11.7012726 13.8609938,11.7297101 13.8475563,11.7612726 C13.7160181,12.073007 13.5560729,12.3719758 13.3697438,12.6543976 C13.0375563,13.1512726 12.7009938,13.5359601 12.1391188,13.7975226 C11.8505946,13.9339946 11.534835,14.0031304 11.2156813,13.9998311 L11.2156813,13.9998311 Z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeleconsult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teleconsult.4989c003.svg";
export { ForwardRef as ReactComponent };